import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import AreaChart from "recharts/es6/chart/AreaChart";
import Area from "recharts/es6/cartesian/Area";
import XAxis from "recharts/es6/cartesian/XAxis";
import YAxis from "recharts/es6/cartesian/YAxis";
import Tooltip from "recharts/es6/component/Tooltip";
import ResponsiveContainer from "recharts/es6/component/ResponsiveContainer";
import SelectionNotAvailable from './SelectionNotAvailable';

const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    return (
      <div
        style={{
          backgroundColor: '#FFF',
          boxShadow: '0 1px 28px 5px rgba(0, 0, 0, 0.06)',
          paddingLeft: '20px',
          paddingTop: '15px',
          paddingRight: '20px',
          paddingBottom: '10px',
        }}
      >
        <div
          style={{
            width: '13px',
            height: '13px',
            backgroundColor: '#2de6d5',
            display: 'inline-block',
          }}
        />
        <p style={{ display: 'inline', paddingLeft: '5px' }}>{`${moment(
          label
        ).format('dddd Do MMMM')} - ${payload[0].value.toFixed(2)}%`}</p>
      </div>
    );
  }

  return null;
};

const FootfallByPercentage = props => (
  <React.Fragment>
    {props.data.length !== 0 && props.isPointlessData === false ? (
      <div className="FootfallOverTimeGraph">
        <div className="FootfallOverTimeGraph_top-row">
          <div className="FootfallOverTimeGraph_top-row_text">
            <h3 className="content-card_title">
              Category share as a percentage
            </h3>
          </div>
        </div>
        <div className="FootfallOverTimeGraph_inner">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={props.data} margin={{ top: 75 }}>
              <XAxis
                dataKey="timestamp"
                tick={{ fontSize: 11 }}
                tickFormatter={tick => moment(tick).format('MMM D')}
              />
              <YAxis
                tick={{ fontSize: 11 }}
                tickFormatter={tick => `${tick}%`}
                domain={[0, 100]}
              />
              />
              <Tooltip
                content={<CustomTooltip />}
                wrapperStyle={{ padding: '10px' }}
              />
              <Area
                type="monotone"
                dataKey="percentage"
                stroke="#2de6d5"
                fill="#2de6d5"
                fillOpacity={0.3}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    ) : (
      <SelectionNotAvailable text="Graph Currently Unavailable" buttonText="" />
    )}
  </React.Fragment>
);

FootfallByPercentage.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  footfallName: PropTypes.string.isRequired,
};

export default FootfallByPercentage;
